import { render } from "./contactSegment.vue?vue&type=template&id=17be3186"
import script from "./contactSegment.vue?vue&type=script&lang=js"
export * from "./contactSegment.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__